import { ProjectTeam, ProjectTeamMember } from "../../../domain/projectTeam";
import { IProjectTeamBean, IProjectTeamMemberBean } from "./beans";
import { UserRepository } from "../../user/ver2";
import { DepartmentRepository } from "../../department/ver2";

export class ProjectTeamTranslator {
  toProjectTeams(beans: IProjectTeamBean[]): ProjectTeam[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toProjectTeam(bean));
  }

  toProjectTeam(bean: IProjectTeamBean): ProjectTeam {
    if (!bean) { return null; }
    const team = new ProjectTeam(bean.id, bean.name, bean.kanaName, DepartmentRepository.toDepartment(bean.department), this.toProjectTeamMembers(bean.members), bean.isDeleted);
    return Object.freeze(team);
  }

  private toProjectTeamMembers(beans: IProjectTeamMemberBean[]): ProjectTeamMember[] {
    if (!beans) { return []; }
    return beans
      .filter(bean => !!bean.user)
      .map(bean => this.toProjectTeamMember(bean));
  }

  private toProjectTeamMember(bean: IProjectTeamMemberBean): ProjectTeamMember {
    const member = new ProjectTeamMember(UserRepository.toUser(bean.user), bean.isManager);
    return Object.freeze(member);
  }
}
